import React, { useState } from "react";
import PropTypes from "prop-types";

import { MdAttachFile } from "react-icons/md";
import { BsEmojiSmile, BsSend } from "react-icons/bs";

import VoiceRecorder from "../../components/record-audio-v2";
import { useAppInfo } from "../../helpers/hooks/common-hook";
import EmojiPicker from "emoji-picker-react";

function ChatForm({
  onChangeInspectData,
  onHandleSubmit,
  sessionId,
  chatBotSetting,
  voiceMode,
}) {
  const { appId, accessKey } = useAppInfo();
  const [question, setQuestion] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [error, setError] = useState({
    question: false,
  });

  const validate = () => {
    let valid = true;
    if (!question) {
      error.question = true;
      valid = false;
    } else {
      error.question = false;
    }

    setError(Object.assign({}, error));
    return valid;
  };

  const onChangeQuestion = (e) => {
    const { value } = e.target;

    if (value.length <= 500) {
      setQuestion(value);
    }
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    if (!validate()) {
      return;
    }

    const currentQuestion = question; // Store the current question
    setQuestion(""); // Clear the input field immediately
    await onHandleSubmit(currentQuestion); // Pass the stored question to the handler
  };

  const onChangeVoiceInvokeState = async (state) => {
    // TODO
    console.log(state);
  };

  const onEmojiClick = (event) => {
    setQuestion((prevQuestion) => prevQuestion + event.emoji);
    setShowEmojiPicker(false);
  };

  return (
    <form
      onSubmit={onSubmit}
      className="border-t lg:border-t-0 border-gray-200 w-full z-10 lg:my-4"
    >
      <div className="input-group flex items-center gap-2 bg-transparent lg:bg-[#f4f4f4] px-2 h-auto min-h-[3rem] rounded">
        <input
          type="text"
          maxLength="500"
          autoComplete="off"
          name="chat-text-input"
          placeholder={chatBotSetting.inputPlaceHolder || "Type a reply..."}
          value={question}
          onChange={onChangeQuestion}
          className="
          m-0 border-none pl-2 outline-none bg-transparent ring-0 flex-1 
          overflow-y-hidden placeholder-gray-300 focus:placeholder-gray-400"
        />

        {/* Form Actions */}
        <div className="form-action-button flex items-center gap-0 relative">
          <button
            type="button"
            onClick={() => setShowEmojiPicker((prev) => !prev)}
            className="group outline-none w-8 h-8 flex-none inline-flex items-center justify-center text-gray-400 hover:text-gray-700"
          >
            <BsEmojiSmile size={17} />
          </button>

          {showEmojiPicker && (
            <div className="absolute bottom-10 right-0 z-50">
              <EmojiPicker onEmojiClick={onEmojiClick} />
            </div>
          )}

          <button
            type="submit"
            className="group outline-none w-8 h-8 flex-none inline-flex items-center justify-center text-gray-400 hover:text-gray-700"
          >
            <BsSend size={17} className="rotate-45" />
          </button>
        </div>
      </div>
    </form>
  );
}

ChatForm.propTypes = {
  onChangeInspectData: PropTypes.func.isRequired,
  onHandleSubmit: PropTypes.func.isRequired,
  sessionId: PropTypes.any,
  voiceMode: PropTypes.any,
  chatBotSetting: PropTypes.object,
};

export default ChatForm;
